import React, { Fragment, useMemo } from 'react';
import useIntls from '@opm/hooks/useIntls';
import { TOptionsItem } from '../../types';

interface MultipleSelectButtonProps {
  value: string[];
  options: TOptionsItem[];
  title: string;
  titleCn: string;
  itemRender?: (item: TOptionsItem, isEn: boolean) => string | JSX.Element;
  maxShow?: number;
  hideComma?: boolean;
  showItemsThreshold?: number; // 选项总数小于该值时，即使全选也展示具体项而非 "All"
}

export const renderOptionItem = (
  item: TOptionsItem,
  isEn: boolean,
  itemRender?: (item: TOptionsItem, isEn: boolean) => string | JSX.Element,
) => {
  if (itemRender) {
    return itemRender(item, isEn);
  }
  return isEn ? item.text : item.textCn;
};

export function MultipleSelectButton({
  value,
  options,
  title,
  titleCn,
  itemRender,
  maxShow = 2,
  hideComma,
  showItemsThreshold = 1,
}: MultipleSelectButtonProps) {
  const { intl, isEn } = useIntls();

  const selectOptions = useMemo(() => {
    return options.filter((item) => value.includes(item.value));
  }, [value, options]);

  const textList = selectOptions.map((item) =>
    renderOptionItem(item, isEn, itemRender),
  );

  const isAll = options.length === textList.length && textList.length >= showItemsThreshold;
  let text: any = textList.length;

  if (textList.length <= maxShow) {
    const list = textList.slice(0, maxShow);
    text = (
      <>
        {list.map((item, index) => (
          <Fragment key={index}>
            {item}{!hideComma && list.length - 1 !== index ? ',' : ''}
          </Fragment>
        ))}
      </>
    );
  }

  if (textList.length === 0) {
    text = intl({ id: 'None' });
  }

  if (isAll) {
    text = intl({ id: 'All' });
  }

  return (
    <div className="dbom-dropdow-button">
      <label className="dbom-dropdow-button-label">
        {isEn ? title : titleCn}
      </label>
      <div className="dbom-dropdow-button-value">{text}</div>
    </div>
  );
}
